































import mixins from 'vue-typed-mixins';
import SurveyUtils, { Survey } from '@/utils/SurveyUtils';
import { DataTableHeader, DataTableCompareFunction } from 'vuetify';
import SurveyDuplicate from '@/components/survey/management/SurveyDuplicate.vue';
export default mixins().extend({
  components: {
    SurveyDuplicate,
  },
  computed: {
    headers(): DataTableHeader<Survey>[] {
      return [
        { text: this.$i18n.tc('model.common.name'), value: 'name.admin' },
        { text: this.$i18n.tc('model.surveyGroup.label'), value: 'surveyGroup.name' },
        { text: this.$i18n.tc('model.common.startdate'), value: 'startdate' },
        { text: this.$i18n.tc('model.common.closedate'), value: 'closedate' },
        { text: this.$i18n.tc('model.common.state'), value: 'state' },
        {
          text: this.$i18n.tc('model.common.participantCount'),
          value: 'participantcount',
        },
      ];
    },
  },
  data(): {
    surveys?: Survey[];
    duplicateSurvey?: Survey;
    search: string;
  } {
    return {
      surveys: undefined,
      duplicateSurvey: undefined,
      search: '',
    };
  },
  async mounted() {
    try {
      this.surveys = await SurveyUtils.api.survey.list();
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
  methods: {
    async create() {
      await this.$router.push({ name: 'survey-create' });
    },
    async edit(survey: Survey) {
      await this.$router.push({
        name: 'survey-edit',
        params: { id: `${survey.id}` },
      });
    },
    async remove(survey: Survey) {
      try {
        if (
          await this.$confirm(
            this.$i18n
              .t('validation.confirmation.delete', [survey.name.admin])
              .toString()
          )
        ) {
          if (survey.id && this.surveys) {
            await SurveyUtils.api.survey.remove(survey.id);

            this.$toast.push({
              type: 'success',
              text: this.$languageobj('validation.success.delete', {
                values: [survey.name.admin],
              }),
            });

            const index = this.surveys.findIndex((val) => val.id === survey.id);
            if (index >= 0) {
              this.surveys.splice(index, 1);
            }
          }
        }
      } catch (error) {
        this.$alert.show('remove', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
    duplicate(survey: Survey) {
      this.duplicateSurvey = survey;
    },
  },
});
